// Code generated by contracts/generate.ts. DO NOT EDIT.
//
// Edit the JSON under contracts/data/ and run `pnpm contracts:generate`.
// CI fails if this file is hand-edited or left stale.

export enum UserRoles {
  /** Full administrative access. */
  Admin = 'admin',
  /** Amplio engineer; unlocks debug surfaces. */
  Developer = 'developer',
  /** Amplio staff. Excluded from play/download analytics. */
  TeamMember = 'teamMember',
  /** Produces songs with the authoring tool. */
  Producer = 'producer',
  /** Performs on songs in the catalog. */
  Musician = 'musician',
  /** Has access to deep-dive content. */
  DeepDiver = 'deepDiver',
  /** Pre-release tester. */
  Tester = 'tester',
  /** Baseline role for any authenticated account. */
  SignedInUser = 'signedInUser',
  /**
   * Holds an active Amplio Plus entitlement. Maintained server-side by
   * setPlusEntitlement from each provider's authoritative state — never
   * derive it from subscriptionStatus.
   */
  Plus = 'plus',
  /** Hearing-health professional. */
  Audiologist = 'audiologist',
}

/** Every role value, in declaration order. */
export const ALL_USER_ROLES: readonly UserRoles[] = Object.freeze([
  UserRoles.Admin,
  UserRoles.Developer,
  UserRoles.TeamMember,
  UserRoles.Producer,
  UserRoles.Musician,
  UserRoles.DeepDiver,
  UserRoles.Tester,
  UserRoles.SignedInUser,
  UserRoles.Plus,
  UserRoles.Audiologist,
]);
